<template>
  <v-row>

    <v-col class="pb-0" cols="12" md="4">
      <el-text-field
        disabled
        label="Vardas"
        v-model="person.name"
      />
    </v-col>
    <v-col class="pb-0" cols="12" md="4">
      <el-text-field
        disabled
        label="Pavardė"
        v-model="person.lastname"
      />
    </v-col>
    <v-col class="pb-0" cols="12" md="4" v-if="person.searchType == 'ak'">
      <el-text-field
        disabled
        label="Asmens kodas"
        v-model="person.code"
      />
    </v-col>
    <v-col class="pb-0" cols="12" md="4" v-if="person.searchType == 'iltu'">
      <el-text-field
        disabled
        label="ILTU"
        v-model="person.iltu_code"
      />
    </v-col>
    <v-col class="pb-0" cols="12" md="4" v-if="person.searchType == 'birth-date-and-country'">
      <el-date-picker
        disabled
        label="Gimimo data"
        pastDates
        v-model="person.birth_date"
      />
    </v-col>
  </v-row>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'RecognizedAsMissing',
  components: {},
  props: {
    person: [Array, Object],
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style>
</style>